import React, { createContext, useContext, useState, useEffect } from 'react';

const ClientAuthContext = createContext();

export const useClientAuth = () => {
  const context = useContext(ClientAuthContext);
  if (!context) {
    throw new Error('useClientAuth must be used within ClientAuthProvider');
  }
  return context;
};

export const ClientAuthProvider = ({ children }) => {
  const [client, setClient] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for saved auth on mount
    const savedToken = localStorage.getItem('sancur-client-token');
    const savedClient = localStorage.getItem('sancur-client');
    
    if (savedToken && savedClient) {
      setToken(savedToken);
      setClient(JSON.parse(savedClient));
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const API_URL = process.env.REACT_APP_BACKEND_URL;
    
    const response = await fetch(`${API_URL}/api/client/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password })
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Login failed');
    }

    const data = await response.json();
    
    setToken(data.token);
    setClient(data.client);
    localStorage.setItem('sancur-client-token', data.token);
    localStorage.setItem('sancur-client', JSON.stringify(data.client));
    
    return data;
  };

  const register = async (name, email, phone, password) => {
    const API_URL = process.env.REACT_APP_BACKEND_URL;
    
    const response = await fetch(`${API_URL}/api/client/register`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name, email, phone, password })
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Registration failed');
    }

    const data = await response.json();
    
    setToken(data.token);
    setClient(data.client);
    localStorage.setItem('sancur-client-token', data.token);
    localStorage.setItem('sancur-client', JSON.stringify(data.client));
    
    return data;
  };

  const logout = () => {
    setToken(null);
    setClient(null);
    localStorage.removeItem('sancur-client-token');
    localStorage.removeItem('sancur-client');
  };

  const getAuthHeaders = () => {
    return token ? { Authorization: `Bearer ${token}` } : {};
  };

  return (
    <ClientAuthContext.Provider value={{
      client,
      token,
      loading,
      isAuthenticated: !!token,
      login,
      register,
      logout,
      getAuthHeaders
    }}>
      {children}
    </ClientAuthContext.Provider>
  );
};

export default ClientAuthContext;
